export function nfseMonthPeriod(date = new Date(), offset = 0) {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Sao_Paulo', year: 'numeric', month: '2-digit' }).formatToParts(date);
  const year = Number(parts.find(part => part.type === 'year').value);
  const month = Number(parts.find(part => part.type === 'month').value) - 1 + offset;
  const first = new Date(Date.UTC(year, month, 1));
  const last = new Date(Date.UTC(year, month + 1, 0));
  return { from: first.toISOString().slice(0, 10), to: last.toISOString().slice(0, 10) };
}
export function inNfsePeriod(note, period) {
  const date = String(note.competenceDate || '').slice(0, 10);
  return (!period.from || date >= period.from) && (!period.to || date <= period.to);
}
